<template>
    <div class="error-wrapper">
        <div class="container">

            <div class="error-heading">
                <h2 class="headline font-success">403</h2>
            </div>
            <div class="col-md-8 offset-md-2">
                <p class="sub-content font-success">QR นี้ยังไม่ได้เปิดใช้งาน (QR code is not activated yet).</p>
            </div>
            <!-- <div><router-link class="btn btn-success-gradien btn-lg" to="/">
                    BACK TO HOME PAGE</router-link></div> -->
        </div>
    </div>
</template>